import React, {useMemo} from "react"
import { compact } from 'lodash'

export function useClasses(classes) {
  return useMemo(() => compact(classes).join(" "), classes)
}